import api from "@/shared/api/api";
import { Method } from "axios";
import { ActionKeyPair } from '@/shared/hooks/useCustomQuery';
import { PaginatedResponse } from "@/features/profiles/services/profiles/types";

interface IPack {
    id: string;
    name: string;
    published: boolean;
    cover: string;
}
export interface Creator {
    id: string;
    name: string;
    avatar: string;
}

export class CreatorService {
    [key: string]: ActionKeyPair<unknown, unknown>;

    getPacksByCreator: ActionKeyPair<
        { id: string },
        IPack[] | null
    > = {
            key: "get-packs-creators",
            actionBuilder: ({ id }) => async () => {
                if (!id) return null;
                return await api({
                    url: `/v1/creators/${id}/packs`,
                    method: "GET" as Method,
                })
            },
        };
    getCreators: ActionKeyPair<undefined, Creator[]> = {
        key: "get-creators",
        actionBuilder: () => async () => {
            const { data } = await api<PaginatedResponse<Creator>>({
                url: "/v1/creators?limit=9999",
                method: "GET" as Method,
            });
            return data
        },
    };
    getCreatorsPaginated: ActionKeyPair<undefined, PaginatedResponse<Creator[]>> = {
        key: "get-creators-paginated",
        actionBuilder: () => async () => {
            return await api<PaginatedResponse<Creator[]>>({
                url: "/v1/creators?limit=9999",
                method: "GET" as Method,
            });
        },
    };

    static Instance = new CreatorService();


}

export default CreatorService;
